import { useState } from 'react';
import { Col, Row, Form, Input, Modal, Divider, Tag } from 'antd';
import { MailOutlined, PhoneOutlined, EditOutlined } from '@ant-design/icons';

import AddressStep from './../Login/registrationForm/AddressStep';
import useFormEditInfo from './Hooks/HookFormEditInfo';




const ModalFormEditInfo = () => {
    const [openModal, setOpenModal] = useState(false);

    const onShowModal = () => setOpenModal(true);
    const onCloseModal = () => setOpenModal(false);

    return (
        <>
            <Col span={24}>
                <Divider>
                    <Tag.CheckableTag style={{ color: '#7c0433', fontWeight: 'bold' }} onClick={onShowModal}>
                        <EditOutlined /> Actualizar información
                    </Tag.CheckableTag>
                </Divider>
            </Col>
            <Modal
                title="Actualizar información personal"
                open={openModal}
                onCancel={onCloseModal}
                footer={null}
                width={1000}
            >
                <FormEditInfo onCancel={onCloseModal} />
            </Modal></>
    )
}

const FormEditInfo = ({ onCancel }) => {

    const {
        form,
        onUpdateInformacion,
        loadingEgresado,
        catLocalidades,
        cpValidated,
        setCpValidated,
        getLocalidadesByCP
    } = useFormEditInfo(onCancel);


    const onFinishFailed = (errorInfo) => {
        //console.log('Failed:', errorInfo);
    }


    return <>
        <Form form={form} onFinish={onUpdateInformacion} onFinishFailed={onFinishFailed}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}>
            <Row align="middle" justify="center">

                <Divider>Información Personal</Divider>
                <Col xs={24} sm={20}>
                    <Form.Item
                        label="Correo personal"
                        name="correo_personal"
                        rules={[
                            { required: true, message: 'Por favor ingresa tu correo personal' },
                            { type: 'email', message: 'Por favor ingresa un correo personal' },
                            { pattern: /^[a-zA-Z0-9_.+-]+@(?!seconalep\.mx$|conalepmex\.edu\.mx$)[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, message: 'Por favor ingresa un correo que no pertenezca a @seconalep.mx ni @conalepmex.edu.mx' }
                        ]
                        }>
                        <Input disabled prefix={<MailOutlined />} placeholder="Ingresa tu correo personal" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={20}>
                    <Form.Item
                        label="Correo alternativo"
                        name="correo_alternativo"
                        rules={[ 
                            { type: 'email', message: 'Por favor ingresa un correo personal alternativo' },
                            { pattern: /^[a-zA-Z0-9_.+-]+@(?!seconalep\.mx$|conalepmex\.edu\.mx$)[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, message: 'Por favor ingresa un correo que no pertenezca a @seconalep.mx ni @conalepmex.edu.mx' }
                        ]
                        }>
                        <Input prefix={<MailOutlined />} placeholder="Ingresa tu correo personal alternativo" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={20}>
                    <Form.Item
                        label="Teléfono personal"
                        name="telefono_personal"
                        rules={[
                            { required: true, message: 'Por favor ingresa tu teléfono personal' },
                            { pattern: /^\d{10}$/, message: 'Por favor ingresa un teléfono personal' }
                        ]}>
                        <Input prefix={<PhoneOutlined />} placeholder="Ingresa tu teléfono personal" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={20}>
                    <Form.Item
                        label="Resumen profesional"
                        name="objetivo_profesional"
                        rules={[
                            { required: true, message: 'Por favor ingresa tu resumen profesional' },
                            { whitespace: true },
                            { min: 10, max: 500, message: 'El resumen profesional debe tener entre 10 y 500 caracteres' },
                        ]}>
                        <Input.TextArea rows={4} placeholder="Ingresa tu resumen profesional" />
                    </Form.Item>
                </Col>
            </Row>

            <Divider>Dirección</Divider>
            <AddressStep
                form={form}
                goNext={onUpdateInformacion}
                goPrev={onCancel}
                cpValidated={cpValidated}
                setCpValidated={setCpValidated}
                catLocalidades={catLocalidades}
                loading={loadingEgresado}
                getLocalidadesByCP={getLocalidadesByCP}
                siteType='editar_informacion' />
        </Form>
    </>
}

export default ModalFormEditInfo;